export enum ResourceEnum {
  AccountingAccount = "accounting-account",
  AccountingPosting = "accounting-posting",
  AccountingPostingPosition = "accounting-posting-position",
  AccountingPostingVacantPosition = "vacant-position",
  AccountingTemplate = "accounting-template",
  Product = "product",
  Attribute = "attribute",
  Category = "category",
  Discount = "discount",
  VoucherSerie = "voucher-serie",
  PaymentMethod = "payment-method",
  Document = "document",
  DeliveryMethod = "delivery-method",
  DeliveryService = "delivery-service",
  Voucher = "voucher",
  CustomerGroup = "customer-group",
  Manufacturer = "manufacturer",
  Supplier = "supplier",
  Order = "order",
  OrderDeliveryService = "order-delivery-service",
  OrderDeliveryServicePosition = "order-delivery-service-position",
  SupplierOrder = "supplier-order",
  SupplierOrderPosition = "supplier-order-position",
  Language = "language",
  Country = "country",
  PriceList = "price-list",
  PriceListItem = "price-list-item",
  Customer = "customer",
  ProductGroup = "product-group",
  Marketplace = "marketplace",
  ProcessingTime = "processing-time",
  OwnerProfile = "owner-profile",
  Owner = "owner",
  Condition = "condition",
  Currency = "currency",
  Unit = "unit",
  ConfigNumber = "config-number",
  IntegrationToken = "integration-token",
  Variant = "variant",
  WarehousePlace = "warehouse-place",
  Warehouse = "warehouse",
  User = "user",
  VariantComponent = "variant-component",
  AccountMovement = "account-movement",
  Role = "role",
  StockMove = "stock-move",
  Stock = "stock",
  Vat = "vat",
  IntAttributeValue = "int-attribute-value",
  AttributeValue = "attribute-value",
  SelectionListAttributeValue = "selection-list-attribute-value",
  FloatAttributeValue = "float-attribute-value",
  DateAttributeValue = "date-attribute-value",
  DateTimeAttributeValue = "date-time-attribute-value",
  TextFieldAttributeValue = "text-field-attribute-value",
  B2bGateOrder = "b2b-gate-order",
  B2bGateSupplierOrder = "b2b-gate-supplier-order",
  B2bGateSupplierOrderPosition = "b2b-gate-supplier-order-position",
  B2bGateSupplier = "b2b-gate-supplier",
  BankAccount = "bank-account",
  BankTransaction = "bank-transaction",
  DocumentTemplate = "document-template",
  EmailTemplate = "email-template",
  Contact = "contact",
  MarketingCompany = "marketing-company",
  BrevoAccount = "brevo-account",
  BankSepa = "bank-sepa",
  Carrier = "carrier",
}

export enum LoginRouteSearchParams {
  From = "from",
  Token = "token",
  Password = "password",
  Login = "login",
}

export enum ErpId {
  Kaufbei = "01KEC8S4KYQX4XMYGA4K04BB4E",
  Stage = "01KR3CY8S10B47Q517DK66VZA9",
  Local = "01J7DYRV23XSYAP2DBASZABQJP",
  ExonnErp = "01KMZ19XDGZBCGX6H35D1B855C",
}
